import { lazy } from 'react';
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from 'react-router-dom';

import { LanguageProvider } from '@providers/LanguageProvider';

import Layout from '../layout/Layout/Layout';

const HomePage = lazy(() => import('@pages/HomePage/HomePage'));

const MarketsPage = lazy(() => import('@pages/MarketsPage/MarketsPage'));

const MtPage = lazy(() => import('@pages/MtPage/MtPage'));
const AccountTypesPage = lazy(
  () => import('@pages/AccountTypesPage/AccountTypesPage')
);

const TutorialsPage = lazy(() => import('@pages/TutorialsPage/TutorialsPage'));
const NewsPage = lazy(() => import('@pages/NewsPage/NewsPage'));
const ArticlePage = lazy(() => import('@pages/ArticlePage/ArticlePage'));

const GlossaryPage = lazy(() => import('@pages/GlossaryPage/GlossaryPage'));
const FaqPage = lazy(() => import('@pages/FaqPage/FaqPage'));

const AboutPage = lazy(() => import('@pages/AboutPage/AboutPage'));
const LegalPackPage = lazy(() => import('@pages/LegalPackPage/LegalPackPage'));

const DocsPage = lazy(() => import('@pages/DocsPage/DocsPage'));

const ContactPage = lazy(() => import('@pages/ContactPage/ContactPage'));

const PartnersPage = lazy(() => import('@pages/PartnersPage/PartnersPage'));

// const router = createBrowserRouter([
//   // {
//   //   path: '/',
//   //   element: <Navigate to="/en" replace />,
//   // },
//   {
//     path: '/',
//     element: (
//       <LanguageProvider>
//         <Layout />
//       </LanguageProvider>
//     ),
//     children: [
//       {
//         index: true,
//         element: <HomePage />,
//       },

//       // === Markets ===
//       {
//         path: 'markets',
//         children: [
//           {
//             path: ':slug',
//             element: <MarketsPage />,
//           },
//         ],
//       },

//       // === Platforms ===
//       {
//         path: 'mt5',
//         element: <MtPage />,
//       },
//       {
//         path: 'account',
//         element: <AccountTypesPage />,
//       },

//       // === Resources ===
//       {
//         path: 'tutorial',
//         children: [
//           {
//             index: true,
//             element: <TutorialsPage />,
//           },
//           {
//             path: ':slug',
//             element: <ArticlePage type="tutorial" />,
//           },
//         ],
//       },
//       {
//         path: 'news',
//         children: [
//           {
//             index: true,
//             element: <NewsPage />,
//           },
//           {
//             path: ':slug',
//             element: <ArticlePage type="news" />,
//           },
//         ],
//       },
//       {
//         path: 'glossary',
//         element: <GlossaryPage />,
//       },
//       {
//         path: 'faq',
//         element: <FaqPage />,
//       },

//       // === Company ===
//       {
//         path: 'about',
//         element: <AboutPage />,
//       },
//       {
//         path: 'legal-pack',
//         children: [
//           {
//             index: true,
//             element: <LegalPackPage />,
//           },
//           {
//             path: ':slug',
//             element: <DocsPage />,
//           },
//         ],
//       },
//       {
//         path: 'contact',
//         element: <ContactPage />,
//       },

//       // === Partners ===
//       {
//         path: 'partners',
//         element: <PartnersPage />,
//       },

//       {
//         path: '*',
//         element: <Navigate to="/" replace />,
//       },
//     ],
//   },
// ]);

const appRoutes = [
  {
    index: true,
    element: <HomePage />,
  },

  // === Markets ===
  {
    path: 'markets',
    children: [
      {
        path: ':slug',
        element: <MarketsPage />,
      },
    ],
  },

  // === Platforms ===
  {
    path: 'mt5',
    element: <MtPage />,
  },
  {
    path: 'account',
    element: <AccountTypesPage />,
  },

  // === Resources ===
  {
    path: 'tutorial',
    children: [
      {
        index: true,
        element: <TutorialsPage />,
      },
      {
        path: ':slug',
        element: <ArticlePage type="tutorial" />,
      },
    ],
  },
  {
    path: 'news',
    children: [
      {
        index: true,
        element: <NewsPage />,
      },
      {
        path: ':slug',
        element: <ArticlePage type="news" />,
      },
    ],
  },
  {
    path: 'glossary',
    element: <GlossaryPage />,
  },
  {
    path: 'faq',
    element: <FaqPage />,
  },

  // === Company ===
  {
    path: 'about',
    element: <AboutPage />,
  },
  {
    path: 'legal-pack',
    children: [
      {
        index: true,
        element: <LegalPackPage />,
      },
      {
        path: ':slug',
        element: <DocsPage />,
      },
    ],
  },
  {
    path: 'contact',
    element: <ContactPage />,
  },

  // === Partners ===
  {
    path: 'partners',
    element: <PartnersPage />,
  },
];

const router = createBrowserRouter([
  {
    path: '/:lang?',
    element: (
      <LanguageProvider>
        <Layout />
      </LanguageProvider>
    ),
    children: appRoutes,
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);

export const AppRouter = () => {
  return <RouterProvider router={router} />;
};
